export function isValuelessAttributeOperator(operator?: string) {
    return operator === "jsonMissing" || operator === "jsonPresent";
}
